export default __webpack_public_path__ + "static/media/LogoBlue.3d7cff24.svg";